import * as THREE from 'three'
import Experience from "./Experience.js"
import CameraControls from 'camera-controls'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'

export default class Camera {
    constructor() {
        this.experience = new Experience()
        this.sizes = this.experience.sizes
        this.scene = this.experience.scene
        this.canvas = this.experience.canvas
        this.time = this.experience.time
        this.debug = this.experience.debug

        //Debug
        if (this.debug.active) {
            this.debugFolder = this.debug.ui.addFolder('Camera').close()
        }

        this.setInstance()
        this.setCameraControls()
        this.update()
    }

    setInstance () {
        this.instance = new THREE.PerspectiveCamera(70, this.sizes.width / this.sizes.height, 0.01, 1000)
        this.instance.position.set(-5.5, 1, 0)
        this.scene.add(this.instance)

        // Debug
        if (this.debug.active) {
            this.debugFolder.add(this.instance.position, 'x').name('CameraX').min(-10).max(10).step(0.001)
            this.debugFolder.add(this.instance.position, 'y').name('CameraY').min(-10).max(10).step(0.001)
            this.debugFolder.add(this.instance.position, 'z').name('CameraZ').min(-10).max(10).step(0.001)
        }
    }

    setCameraControls () {

        // // Camera-Controls
        // CameraControls.install({ THREE: THREE })
        // this.controls = new CameraControls(this.instance, this.canvas)
        // this.controls.enableDamping = true
        // this.controls.draggingDampingFactor = .05

        // this.controls.truck = false

        // Orbit-Controls
        this.targetPosition = new THREE.Vector3(0, .5, 0)


        this.controls = new OrbitControls(this.instance, this.canvas)
        this.controls.enableDamping = true
        this.controls.target = this.targetPosition
        this.controls.minDistance = .5
        this.controls.maxDistance = 6.9

        this.controls.addEventListener("change", this.updateTarget.bind(this))

        // Debug
        if (this.debug.active) {
            this.debugFolder.add(this.targetPosition, 'y').name('TargetY').min(-2).max(2).step(0.0001).onChange(this.updateTarget.bind(this))
        }

    }

    updateTarget () {
        this.minPan = new THREE.Vector3(0, - 2, 0)
        this.maxPan = new THREE.Vector3(0, 2, 0)
        this._v = new THREE.Vector3()

        this._v.copy(this.controls.target)
        this.controls.target.clamp(this.minPan, this.maxPan)
        this._v.sub(this.controls.target)
        this.instance.position.sub(this._v)
    }

    resize () {
        this.instance.aspect = this.sizes.width / this.sizes.height
        this.instance.updateProjectionMatrix()
    }

    update () {
        // // Camera-Controls
        // this.controls.update(this.time.delta)

        // Orbit-Controls
        this.controls.update()
    }
}